import { CalendarIcon } from '../../../assets/icons/CalendarIcon';
import { DocumentIcon } from '../../../assets/icons/DocumentIcon';
import { ListingsIcon } from '../../../assets/icons/ListingsIcon';
import { PerfomanceIcon } from '../../../assets/icons/PerfomanceIcon';
import { RatingIcon } from '../../../assets/icons/RatingIcon';
import { useSelector } from "react-redux";
//import { SettingsIcon } from "../../../assets/icons/SettingsIcon";
//import { ContactIcon } from "../../../assets/icons/ContactIcon";
import { userDataSelector } from "../../../redux/selectors/userDataSelector";


export const mainMenuItems = [
  {
    id: 'perfomance',
    label: 'Performance',
    icon: <PerfomanceIcon />,
    url: '/perfomance',
  },
  {
    id: 'rating',
    label: 'Rating',
    icon: <RatingIcon />,
    url: '/rating',
  },
  {
    id: 'calendar',
    label: 'Calendar',
    icon: <CalendarIcon />,
    url: '/calendar',
  },
  {
    id: 'listings',
    label: 'Listings',
    icon: <ListingsIcon />,
    url: '/listings',
  },
  {
    id: 'documents',
    label: 'Documents',
    icon: <DocumentIcon />,
    url: '/documents',
  },
];

// export const mobileMenuItems = [
//   {
//     id: 'perfomance',
//     label: 'Performance',
//     icon: <PerfomanceIcon />,
//     url: '/perfomance',
//   },
//   {
//     id: 'rating',
//     label: 'Rating',
//     icon: <RatingIcon />,
//     url: '/rating',
//   },
//   {
//     id: 'calendar',
//     label: 'Calendar',
//     icon: <CalendarIcon />,
//     url: '/calendar',
//   },
//   {
//     id: 'listings',
//     label: 'Listings',
//     icon: <ListingsIcon />,
//     url: '/listings',
//   },
//   {
//     id: 'documents',
//     label: 'Documents',
//     icon: <DocumentIcon />,
//     url: '/documents',
//   },
// ];

export function useMobileMenuItems() {
  const userData = useSelector(userDataSelector);

  const menu = [
    { id: "perfomance", label: "Performance", icon: <PerfomanceIcon />, url: "/perfomance" },
    { id: "rating", label: "Rating", icon: <RatingIcon />, url: "/rating" },
    { id: "calendar", label: "Calendar", icon: <CalendarIcon />, url: "/calendar" },
    { id: "listings", label: "Listings", icon: <ListingsIcon />, url: "/listings" },
    { id: "documents", label: "Documents", icon: <DocumentIcon />, url: "/documents" },
  ];

  // If Pricelabs user → remove specific items
  if (userData?.source === "pricelabs") {
    const removeIds = ["listings", "rating"];
    return menu.filter((item) => !removeIds.includes(item.id));
  }

  return menu;
}

export const additionalMenuItems = [
  // {
  //   id: "listings",
  //   label: "Listings",
  //   icon: <ListingsIcon />,
  //   url: "/listings"
  // },
  // {
  //   id: "documents",
  //   label: "Documents",
  //   icon: <DocumentIcon />,
  //   url: "/documents"
  // },
  /*{
    id: "settings",
    label: "Settings",
    icon: <SettingsIcon />,
    url: "/settings"
  },
  */
  /*
  {
    id: "contacts",
    label: "Contacts",
    icon: <ContactIcon />,
    url: "/contacts"
  }
  */
];
